module.exports = __webpack_public_path__ + "static/sjova-6-c5eec8a25257381ae614368796f70c9c.jpg";